import { motion, AnimatePresence } from 'motion/react';
import { useState } from 'react';
import type { WorkOption } from '../types';
import { workOptionMockupMap } from '../config/workOptions';

interface ApplicationPreviewProps {
  workOption: WorkOption | null;
}

export function ApplicationPreview({ workOption }: ApplicationPreviewProps): JSX.Element | null {
  if (!workOption) return null;

  const mockup = workOptionMockupMap[workOption];
  const [imageLoaded, setImageLoaded] = useState(false);

  return (
    <div className="absolute -right-[630px] -bottom-[100px] w-[1440px] h-[785px] rounded-2xl overflow-hidden">
      <AnimatePresence mode="wait">
        <div key={workOption} className="relative w-full h-full">
          {!imageLoaded && (
            <div className="absolute inset-0 bg-gradient-to-br from-gray-200 to-gray-300 animate-pulse" />
          )}
          <motion.img
            key={workOption}
            src={`${mockup}?w=1440&h=785&fit=cover`}
            alt={`Application preview for ${workOption}`}
            className="w-full h-auto object-contain border-[20px] border-white/80"
            loading="lazy"
            onLoad={() => setImageLoaded(true)}
            initial={{ opacity: 0, scale: 0.95, y: 20 }}
            animate={{ opacity: imageLoaded ? 1 : 0, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 20 }}
            transition={{ duration: 0.5, ease: 'easeInOut' }}
          />
        </div>
      </AnimatePresence>
    </div>
  );
}
